import Injectables from 'constant/Injectables';
import { repository } from '@trlogic/client-js';
import { MemoryDb } from 'minimongo';
import { InstanceContainer } from './InstanceBinding';

export const registerRepositories = () => {
  const localDb: MemoryDb = InstanceContainer.get(Injectables.LOCAL_DB);
  const _repository: repository.ReadOnlyQueryableRepository = new repository.MongoGenericReadOnlyQueryableRepository(localDb);
  InstanceContainer.bind(Injectables.REPOSITORY).toConstantValue(_repository);
};
